import React, { Component } from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { withNamespaces, Trans } from 'react-i18next';
import { loadWorkshops } from '../../dashboard/common/actions';
import { updateSelectedCenter } from '../../dashboard/actions';
import { Link } from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import { Row, Col, Table } from 'react-bootstrap';
import CenterDetailsLink from '../../common/components/CenterDetailsLink';
import moment from 'moment';

class Workshops extends Component {
	componentDidMount() {
		const { searchParams: { centerId }, loadWorkshops, parent, updateSelectedCenter } = this.props;
		if (centerId) {
			loadWorkshops(centerId);

			if (parent.id > 0) { // update parent's center if parent is logged in
				updateSelectedCenter(centerId, this.props.history, false);
			}
		}
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.parent.id === 0 && nextProps.parent.id > 0) { // update parent's center if parent is logged in
			this.props.updateSelectedCenter(nextProps.searchParams.centerId, nextProps.history, false);
		}
	}

	render() {
		const { searchParams: { centerId }, center, workshops, t } = this.props;

		return <div className='timetable-wrapper'>
			<h3>
				<Trans i18nKey='FO_Workshops_InfoMessage_Center'>
					Workshops in <CenterDetailsLink center={center} hideMapMarker />
				</Trans>
			</h3>
			{workshops.sort((a, b) => moment(a.startDate) - moment(b.startDate)).map(workshop => <div key={workshop.id}>
				<h4>{workshop.name}</h4>
				<div>{workshop.shortDescription}</div>
				<Table className='table-expanded' responsive hover>
					<thead>
						<tr>
							<th>{t('FO_Workshops_Week')}</th>
							<th>{t('FO_Workshops_WeekDates')}</th>
						</tr>
					</thead>
					<tbody>
						{workshop.weeks.sort((a, b) => moment(a.startDate) - moment(b.startDate)).map(week => <tr key={week.id}>
							<td>{week.name}</td>
							<td>{`${moment(week.startDate).format('ll, ddd')} - ${moment(week.endDate).format('ll, ddd')}`}</td>
						</tr>)}
					</tbody>
				</Table>
				<Link className='btn btn-primary btn-xss' to={`/public/workshops/${centerId}/${workshop.id}`}>{t('FO_Program_InfoAndBooking')}  <i className='fa fa-arrow-circle-right' /></Link>
				<hr />
			</div>)}
			{workshops.length == 0 && <div style={{ textAlign: 'center' }} className='text-muted'>{t('FO_Common_NoResults')}</div>}
			<Row style={{ paddingTop: '10px' }}>
				<Col sm={12}>
					<Link className='btn btn-primary btn-block-xxs pull-right' to={`/public/timetable?centerId=${centerId}`}>{t('FO_MainMenu_Parent_Classes')} <FontAwesome name='arrow-circle-right' /></Link>
					<Link className='btn btn-back btn-block-xxs' to={{ pathname: '/public/centers', search: '?reset=true', state: { referrer: 'workshops' } }}><FontAwesome name='arrow-circle-left' /> {t('FO_Booking_Center_Select')}</Link>
				</Col>
			</Row>
		</div>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const queryParams = queryString.parse(ownProps.location.search);
	const selectedCenterId = queryParams.centerId ? Number(queryParams.centerId) : null;

	const {
		entities: { workshops, centers },
		filters: { workshopsByCenter },
		parent
	} = state;

	const workshopsFilter = selectedCenterId && workshopsByCenter[selectedCenterId] || { ids: [] };

	return {
		searchParams: {
			centerId: selectedCenterId
		},
		center: centers[selectedCenterId],
		workshops: workshopsFilter.ids.map(id => workshops[id]),
		parent
	}
};

export default connect(mapStateToProps, {
	loadWorkshops,
	updateSelectedCenter
})(withNamespaces()(Workshops));